import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <AboutSection />
        <CommentsSection />
        <TopicsSection />
        <CardsSection />
        <FaqSection />
        <RankingSection />
        <UpdatesSection />
        <ContactSection />
        <FeaturesSection />
        <CarouselSection />
        <MediaSection />
        <AppSection />
      </main>
      <Footer />
    </div>
  );
}